import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class OtaService {

  constructor(private http: HttpClientService) { }


  public actualizacion(idLuminaria: string) {

    let json =
      {
        "idLuminaria": idLuminaria
      };

    return this.http.post('/ota/actualizacion', JSON.stringify(json));
  }

  public actualizacionAutomatica(idProyecto: string) {

    let json =
      {
        "idProyecto": idProyecto
      };

    return this.http.post('/ota/actualizacionAutomatica', JSON.stringify(json));
  }

  public setFirmware(idLuminaria: string, versionFirmware: string) {

    let json =
      {
        "idLuminaria": idLuminaria,
        "versionFirmware": versionFirmware
      };

    return this.http.post('/ota/setfirmware', JSON.stringify(json));
  }

  public abort(idLuminaria: string, idProyecto: string) {

    let json =
      {
        "idLuminaria": idLuminaria,
        "idProyecto": idProyecto
      };

    return this.http.post('/ota/abort', JSON.stringify(json));
  }

  public setSelected(idLuminaria: string, selected: boolean) {

    let json =
      {
        "idLuminaria": idLuminaria,
        "selected": selected
      };

    return this.http.post('/ota/setselected', JSON.stringify(json));
  }

  public setSort(idLuminaria: string) {
    let json =
      {
        "idLuminaria": idLuminaria
      };

    return this.http.post('/ota/setsort', JSON.stringify(json));
  }
}
